import { zGraphemeString } from '../../../../validation/grapheme';
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SAS Online Clinic Backend API
 * SASオンラインクリニックのバックエンドAPI仕様。分割YAML構成で管理し、RedoclyとSpectralで検証します。
 * OpenAPI spec version: 0.1.0
 */
import * as zod from 'zod';


/**
 * CPAP処方指示書を新規作成します（status=draft）。
 * 管理番号はSEQUENCEから自動採番されます。
 * draft 保存では doctorUserId と instructionDate を未入力にできます。
 *
 * RBAC:
 * - 許可: clinic-doctor, clinic-operator
 * @summary CPAP処方指示書を新規作成する
 */
export const cpapPrescriptionCreateBodyBillingStartYearMin = 1900;
export const cpapPrescriptionCreateBodyBillingStartYearMax = 2100;

export const cpapPrescriptionCreateBodyBillingStartMonthMax = 12;



export const CpapPrescriptionCreateBody = zod.object({
  "patientId": zod.string().uuid().describe('対象患者ID'),
  "doctorUserId": zod.string().uuid().nullish().describe('医師ユーザーID（draft では未入力可）'),
  "clinicOrganizationId": zod.string().uuid().describe('クリニック組織ID'),
  "orderType": zod.enum(['新規', '処方変更', 'マスク変更', '機種変更', '中止', '再開']).describe('オーダー種別'),
  "instructionDate": zod.string().date().nullish().describe('指示日（YYYY-MM-DD、draft では未入力可）'),
  "billingStartYear": zod.number().int().min(cpapPrescriptionCreateBodyBillingStartYearMin).max(cpapPrescriptionCreateBodyBillingStartYearMax).nullish().describe('算定開始年（YYYY、draft では未入力可）'),
  "billingStartMonth": zod.number().int().min(1).max(cpapPrescriptionCreateBodyBillingStartMonthMax).nullish().describe('算定開始月（1-12、draft では未入力可）'),
  "prescriptionContent": zod.object({

}).passthrough().optional().describe('処方内容（任意フィールド、下書き保存時は部分的な入力を許容）')
}).strict().describe('CPAP処方指示書の新規作成リクエスト')

export const cpapPrescriptionCreateResponseBillingStartYearMin = 1900;
export const cpapPrescriptionCreateResponseBillingStartYearMax = 2100;

export const cpapPrescriptionCreateResponseBillingStartMonthMax = 12;



export const CpapPrescriptionCreateResponse = zod.object({
  "prescriptionId": zod.string().uuid().describe('処方指示書ID'),
  "orderNumber": zod.string().describe('管理番号（7桁0埋め）'),
  "organizationId": zod.string().uuid().describe('組織ID'),
  "patientId": zod.string().uuid().describe('患者ID'),
  "doctorUserId": zod.string().uuid().nullish().describe('医師ユーザーID（draft では未設定の場合あり）'),
  "doctorName": zod.string().describe('担当医師名'),
  "clinicOrganizationId": zod.string().uuid().describe('クリニック組織ID'),
  "orderType": zod.enum(['新規', '処方変更', 'マスク変更', '機種変更', '中止', '再開']).describe('オーダー種別'),
  "instructionDate": zod.string().date().nullish().describe('指示日（YYYY-MM-DD、draft では未設定の場合あり）'),
  "billingStartYear": zod.number().int().min(cpapPrescriptionCreateResponseBillingStartYearMin).max(cpapPrescriptionCreateResponseBillingStartYearMax).nullish().describe('算定開始年（YYYY、draft では未設定の場合あり）'),
  "billingStartMonth": zod.number().int().min(1).max(cpapPrescriptionCreateResponseBillingStartMonthMax).nullish().describe('算定開始月（1-12、draft では未設定の場合あり）'),
  "status": zod.enum(['draft', 'submitted', 'consented', 'rejected']).describe('ステータス'),
  "prescriptionContent": zod.object({

}).passthrough().describe('処方内容（No.3〜61のフィールドをJSONBで格納）'),
  "inventoryContent": zod.object({

}).passthrough().nullish().describe('在庫管理内容（No.62〜71、オペレーター入力）'),
  "consentedAt": zod.string().datetime({"offset":true}).nullable().describe('患者同意日時（未同意の場合はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('CPAP処方指示書')

/**
 * 指定された処方指示書（prescriptionId）の詳細情報を返します。
 *
 * RBAC:
 * - 許可: 全ロール
 * @summary CPAP処方指示書の詳細を取得する
 */
export const CpapPrescriptionGetParams = zod.object({
  "prescriptionId": zod.string().uuid().describe('処方指示書ID（UUID）')
}).strict()

export const cpapPrescriptionGetResponseBillingStartYearMin = 1900;
export const cpapPrescriptionGetResponseBillingStartYearMax = 2100;

export const cpapPrescriptionGetResponseBillingStartMonthMax = 12;



export const CpapPrescriptionGetResponse = zod.object({
  "prescriptionId": zod.string().uuid().describe('処方指示書ID'),
  "orderNumber": zod.string().describe('管理番号（7桁0埋め）'),
  "organizationId": zod.string().uuid().describe('組織ID'),
  "patientId": zod.string().uuid().describe('患者ID'),
  "doctorUserId": zod.string().uuid().nullish().describe('医師ユーザーID（draft では未設定の場合あり）'),
  "doctorName": zod.string().describe('担当医師名'),
  "clinicOrganizationId": zod.string().uuid().describe('クリニック組織ID'),
  "orderType": zod.enum(['新規', '処方変更', 'マスク変更', '機種変更', '中止', '再開']).describe('オーダー種別'),
  "instructionDate": zod.string().date().nullish().describe('指示日（YYYY-MM-DD、draft では未設定の場合あり）'),
  "billingStartYear": zod.number().int().min(cpapPrescriptionGetResponseBillingStartYearMin).max(cpapPrescriptionGetResponseBillingStartYearMax).nullish().describe('算定開始年（YYYY、draft では未設定の場合あり）'),
  "billingStartMonth": zod.number().int().min(1).max(cpapPrescriptionGetResponseBillingStartMonthMax).nullish().describe('算定開始月（1-12、draft では未設定の場合あり）'),
  "status": zod.enum(['draft', 'submitted', 'consented', 'rejected']).describe('ステータス'),
  "prescriptionContent": zod.object({

}).passthrough().describe('処方内容（No.3〜61のフィールドをJSONBで格納）'),
  "inventoryContent": zod.object({

}).passthrough().nullish().describe('在庫管理内容（No.62〜71、オペレーター入力）'),
  "consentedAt": zod.string().datetime({"offset":true}).nullable().describe('患者同意日時（未同意の場合はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('CPAP処方指示書')

/**
 * 指定された処方指示書（prescriptionId）を部分更新します。
 * - submitted 以降は inventoryContent 以外の医療者フィールドは凍結（409）
 * - inventoryContent は OPS スコープのみ更新可。CLINIC スコープから inventoryContent を更新すると 403
 * - prescriptionContent, status, orderType, doctorUserId, instructionDate は CLINIC スコープのみ更新可。OPS からこれらを更新すると 403
 * - status=submitted への変更時、同一患者に既存のsubmittedがあれば409
 *
 * RBAC:
 * - 許可: clinic-doctor, clinic-operator, ops-admin, ops-operator
 * @summary CPAP処方指示書を更新する
 */
export const CpapPrescriptionUpdateParams = zod.object({
  "prescriptionId": zod.string().uuid().describe('処方指示書ID（UUID）')
}).strict()

export const cpapPrescriptionUpdateBodyBillingStartYearMin = 1900;
export const cpapPrescriptionUpdateBodyBillingStartYearMax = 2100;

export const cpapPrescriptionUpdateBodyBillingStartMonthMax = 12;



export const CpapPrescriptionUpdateBody = zod.object({
  "status": zod.enum(['submitted']).optional().describe('ステータス変更（draft→submitted のみ許可、CLINICスコープのみ）'),
  "orderType": zod.enum(['新規', '処方変更', 'マスク変更', '機種変更', '中止', '再開']).optional().describe('オーダー種別'),
  "instructionDate": zod.string().date().nullish().describe('指示日（YYYY-MM-DD、draft 保存時は未入力可）'),
  "billingStartYear": zod.number().int().min(cpapPrescriptionUpdateBodyBillingStartYearMin).max(cpapPrescriptionUpdateBodyBillingStartYearMax).nullish().describe('算定開始年（YYYY、draft 保存時は未入力可）'),
  "billingStartMonth": zod.number().int().min(1).max(cpapPrescriptionUpdateBodyBillingStartMonthMax).nullish().describe('算定開始月（1-12、draft 保存時は未入力可）'),
  "doctorUserId": zod.string().uuid().nullish().describe('医師ユーザーID（draft 保存時は未入力可）'),
  "prescriptionContent": zod.object({

}).passthrough().optional().describe('処方内容（No.3〜61）'),
  "inventoryContent": zod.object({

}).passthrough().optional().describe('在庫管理内容（No.62〜71、オペレーターのみ更新可）')
}).strict().describe('CPAP処方指示書の更新リクエスト（部分更新）')

export const cpapPrescriptionUpdateResponseBillingStartYearMin = 1900;
export const cpapPrescriptionUpdateResponseBillingStartYearMax = 2100;

export const cpapPrescriptionUpdateResponseBillingStartMonthMax = 12;



export const CpapPrescriptionUpdateResponse = zod.object({
  "prescriptionId": zod.string().uuid().describe('処方指示書ID'),
  "orderNumber": zod.string().describe('管理番号（7桁0埋め）'),
  "organizationId": zod.string().uuid().describe('組織ID'),
  "patientId": zod.string().uuid().describe('患者ID'),
  "doctorUserId": zod.string().uuid().nullish().describe('医師ユーザーID（draft では未設定の場合あり）'),
  "doctorName": zod.string().describe('担当医師名'),
  "clinicOrganizationId": zod.string().uuid().describe('クリニック組織ID'),
  "orderType": zod.enum(['新規', '処方変更', 'マスク変更', '機種変更', '中止', '再開']).describe('オーダー種別'),
  "instructionDate": zod.string().date().nullish().describe('指示日（YYYY-MM-DD、draft では未設定の場合あり）'),
  "billingStartYear": zod.number().int().min(cpapPrescriptionUpdateResponseBillingStartYearMin).max(cpapPrescriptionUpdateResponseBillingStartYearMax).nullish().describe('算定開始年（YYYY、draft では未設定の場合あり）'),
  "billingStartMonth": zod.number().int().min(1).max(cpapPrescriptionUpdateResponseBillingStartMonthMax).nullish().describe('算定開始月（1-12、draft では未設定の場合あり）'),
  "status": zod.enum(['draft', 'submitted', 'consented', 'rejected']).describe('ステータス'),
  "prescriptionContent": zod.object({

}).passthrough().describe('処方内容（No.3〜61のフィールドをJSONBで格納）'),
  "inventoryContent": zod.object({

}).passthrough().nullish().describe('在庫管理内容（No.62〜71、オペレーター入力）'),
  "consentedAt": zod.string().datetime({"offset":true}).nullable().describe('患者同意日時（未同意の場合はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('CPAP処方指示書')

/**
 * 指定された処方指示書（prescriptionId）に患者が同意します。
 * request body の consented は true のみ受け付けます。
 * request body には画面に表示した同意文書バージョンと文言スナップショットを含めます。
 * status=submittedの場合のみ操作可能。それ以外は409。
 *
 * RBAC:
 * - 許可: patient-user
 * @summary CPAP処方指示書に患者が同意する
 */
export const CpapPrescriptionConsentParams = zod.object({
  "prescriptionId": zod.string().uuid().describe('処方指示書ID（UUID）')
}).strict()








export const CpapPrescriptionConsentBody = zod.object({
  "consented": zod.boolean().describe('同意時のみ true を指定する'),
  "consentVersion": zGraphemeString({ min: 1 }).describe('画面に表示した同意文書のバージョン'),
  "presentedClauses": zod.array(zGraphemeString({ min: 1 })).min(1).describe('画面に表示した同意条項のスナップショット'),
  "presentedPrivacyPurposes": zod.array(zGraphemeString({ min: 1 })).min(1).describe('画面に表示した個人情報利用目的のスナップショット')
}).strict().describe('CPAP処方指示書への患者同意リクエスト')

export const cpapPrescriptionConsentResponseBillingStartYearMin = 1900;
export const cpapPrescriptionConsentResponseBillingStartYearMax = 2100;

export const cpapPrescriptionConsentResponseBillingStartMonthMax = 12;



export const CpapPrescriptionConsentResponse = zod.object({
  "prescriptionId": zod.string().uuid().describe('処方指示書ID'),
  "orderNumber": zod.string().describe('管理番号（7桁0埋め）'),
  "organizationId": zod.string().uuid().describe('組織ID'),
  "patientId": zod.string().uuid().describe('患者ID'),
  "doctorUserId": zod.string().uuid().nullish().describe('医師ユーザーID（draft では未設定の場合あり）'),
  "doctorName": zod.string().describe('担当医師名'),
  "clinicOrganizationId": zod.string().uuid().describe('クリニック組織ID'),
  "orderType": zod.enum(['新規', '処方変更', 'マスク変更', '機種変更', '中止', '再開']).describe('オーダー種別'),
  "instructionDate": zod.string().date().nullish().describe('指示日（YYYY-MM-DD、draft では未設定の場合あり）'),
  "billingStartYear": zod.number().int().min(cpapPrescriptionConsentResponseBillingStartYearMin).max(cpapPrescriptionConsentResponseBillingStartYearMax).nullish().describe('算定開始年（YYYY、draft では未設定の場合あり）'),
  "billingStartMonth": zod.number().int().min(1).max(cpapPrescriptionConsentResponseBillingStartMonthMax).nullish().describe('算定開始月（1-12、draft では未設定の場合あり）'),
  "status": zod.enum(['draft', 'submitted', 'consented', 'rejected']).describe('ステータス'),
  "prescriptionContent": zod.object({

}).passthrough().describe('処方内容（No.3〜61のフィールドをJSONBで格納）'),
  "inventoryContent": zod.object({

}).passthrough().nullish().describe('在庫管理内容（No.62〜71、オペレーター入力）'),
  "consentedAt": zod.string().datetime({"offset":true}).nullable().describe('患者同意日時（未同意の場合はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('CPAP処方指示書')

/**
 * 指定された患者（patientId）のCPAP処方指示書一覧を返します。
 * statusでフィルタ可能。
 *
 * RBAC:
 * - 許可: 全ロール
 * @summary 患者のCPAP処方指示書一覧を取得する
 */
export const CpapPrescriptionListByPatientParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）')
}).strict()

export const CpapPrescriptionListByPatientQueryParams = zod.object({
  "status": zod.enum(['draft', 'submitted', 'consented', 'rejected']).optional().describe('ステータスでフィルタ')
}).strict()

export const cpapPrescriptionListByPatientResponseItemsItemBillingStartYearMin = 1900;
export const cpapPrescriptionListByPatientResponseItemsItemBillingStartYearMax = 2100;

export const cpapPrescriptionListByPatientResponseItemsItemBillingStartMonthMax = 12;



export const CpapPrescriptionListByPatientResponse = zod.object({
  "items": zod.array(zod.object({
  "prescriptionId": zod.string().uuid().describe('処方指示書ID'),
  "orderNumber": zod.string().describe('管理番号（7桁0埋め）'),
  "organizationId": zod.string().uuid().describe('組織ID'),
  "patientId": zod.string().uuid().describe('患者ID'),
  "doctorUserId": zod.string().uuid().nullish().describe('医師ユーザーID（draft では未設定の場合あり）'),
  "doctorName": zod.string().describe('担当医師名'),
  "clinicOrganizationId": zod.string().uuid().describe('クリニック組織ID'),
  "orderType": zod.enum(['新規', '処方変更', 'マスク変更', '機種変更', '中止', '再開']).describe('オーダー種別'),
  "instructionDate": zod.string().date().nullish().describe('指示日（YYYY-MM-DD、draft では未設定の場合あり）'),
  "billingStartYear": zod.number().int().min(cpapPrescriptionListByPatientResponseItemsItemBillingStartYearMin).max(cpapPrescriptionListByPatientResponseItemsItemBillingStartYearMax).nullish().describe('算定開始年（YYYY、draft では未設定の場合あり）'),
  "billingStartMonth": zod.number().int().min(1).max(cpapPrescriptionListByPatientResponseItemsItemBillingStartMonthMax).nullish().describe('算定開始月（1-12、draft では未設定の場合あり）'),
  "status": zod.enum(['draft', 'submitted', 'consented', 'rejected']).describe('ステータス'),
  "prescriptionContent": zod.object({

}).passthrough().describe('処方内容（No.3〜61のフィールドをJSONBで格納）'),
  "inventoryContent": zod.object({

}).passthrough().nullish().describe('在庫管理内容（No.62〜71、オペレーター入力）'),
  "consentedAt": zod.string().datetime({"offset":true}).nullable().describe('患者同意日時（未同意の場合はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('CPAP処方指示書')).describe('処方指示書の一覧')
}).strict().describe('CPAP処方指示書一覧レスポンス')

/**
 * 対象患者・対象年月の組み合わせで、平均AHI・装着率・平均使用時間を登録する。
 * 同一の対象年月に既存データがある場合は上書き更新する（履歴は保持しない）。
 *
 * RBAC:
 * - 許可: ops-admin, ops-operator のみ
 * @summary CPAP治療実績（期間集計値）を登録・上書き更新する
 */
export const cpapTreatmentSummaryUpsertBodyTargetYearMin = 1900;
export const cpapTreatmentSummaryUpsertBodyTargetYearMax = 2100;

export const cpapTreatmentSummaryUpsertBodyTargetMonthMax = 12;

export const cpapTreatmentSummaryUpsertBodyAvgAhiMin = 0;
export const cpapTreatmentSummaryUpsertBodyAvgAhiMax = 200;

export const cpapTreatmentSummaryUpsertBodyUsageRateMin = 0;
export const cpapTreatmentSummaryUpsertBodyUsageRateMax = 100;

export const cpapTreatmentSummaryUpsertBodyAvgUsageHoursMin = 0;
export const cpapTreatmentSummaryUpsertBodyAvgUsageHoursMax = 24;



export const CpapTreatmentSummaryUpsertBody = zod.object({
  "patientId": zod.string().uuid().describe('対象患者ID'),
  "targetYear": zod.number().int().min(cpapTreatmentSummaryUpsertBodyTargetYearMin).max(cpapTreatmentSummaryUpsertBodyTargetYearMax).describe('対象年（YYYY）'),
  "targetMonth": zod.number().int().min(1).max(cpapTreatmentSummaryUpsertBodyTargetMonthMax).describe('対象月（1-12）'),
  "avgAhi": zod.number().min(cpapTreatmentSummaryUpsertBodyAvgAhiMin).max(cpapTreatmentSummaryUpsertBodyAvgAhiMax).describe('平均AHI（回/時、使用日数を分母とする平均）'),
  "usageRate": zod.number().min(cpapTreatmentSummaryUpsertBodyUsageRateMin).max(cpapTreatmentSummaryUpsertBodyUsageRateMax).describe('装着率（%、対象期間の全日数を分母とする使用日数の割合）'),
  "avgUsageHours": zod.number().min(cpapTreatmentSummaryUpsertBodyAvgUsageHoursMin).max(cpapTreatmentSummaryUpsertBodyAvgUsageHoursMax).describe('平均使用時間（時間/日、対象期間の全日数を分母とする平均）')
}).strict().describe('CPAP治療実績（期間集計値）登録・上書き更新リクエスト')

export const CpapTreatmentSummaryUpsertResponse = zod.object({
  "id": zod.string().uuid().optional(),
  "organizationId": zod.string().uuid().optional(),
  "patientId": zod.string().uuid().optional(),
  "clinicOrganizationId": zod.string().uuid().optional(),
  "periodStart": zod.string().datetime({"offset":true}).optional(),
  "periodEnd": zod.string().datetime({"offset":true}).optional(),
  "avgAhi": zod.number().optional(),
  "usageRate": zod.number().nullish(),
  "avgUsageHours": zod.number().optional(),
  "source": zod.enum(['manual']).optional(),
  "createdAt": zod.string().datetime({"offset":true}).optional(),
  "updatedAt": zod.string().datetime({"offset":true}).optional()
}).strict().describe('CPAP治療実績（期間集計値）')

